import type { TCustomer } from '../../../types/apps'

export const getGroupStructure = (
  uniqueID: string | number,
  disabled?: boolean,
  integrationConfigurationID?: string
) => {
  return {
    [uniqueID]: [
      {
        disabled: disabled || false,
        integrationConfigurationID: integrationConfigurationID || '',
        isRequired: true,
        labelText: 'CustomerID ( Bill To )',
        name: `customerID-${uniqueID}`,
        placeholder: 'Enter customer\'s "Bill To" from FourKites'
      },
      {
        disabled: disabled || false,
        integrationConfigurationID: integrationConfigurationID || '',
        labelText: 'Customer Name ( In Chaine )',
        name: `customerNameInChaine-${uniqueID}`,
        placeholder: "Enter the customer's name in Chaine"
      },
      {
        disabled: disabled || false,
        integrationConfigurationID: integrationConfigurationID || '',
        labelText: 'Customer ID ( In Chaine )',
        name: `customerIDInChaine-${uniqueID}`,
        placeholder: "Enter the customer's ID in Chaine"
      }
    ]
  }
}

export const getPayloadStructure = (event: Record<string, string>): { apiKey: string; customers: TCustomer[] } => {
  const result: Record<string, string | TCustomer[]> = {
    apiKey: event.apiKey,
    customers: []
  }
  const customerData: Record<string, TCustomer> = {}
  for (const [key, value] of Object.entries(event)) {
    const match = key.match(/(customerID|customerNameInChaine|customerIDInChaine)-(.+)/)
    if (match) {
      const [, property, id] = match
      if (!customerData[id]) {
        customerData[id] = {
          customerID: '',
          customerIDInChaine: null,
          customerNameInChaine: null
        } as TCustomer
      }
      customerData[id][property as keyof TCustomer] = value as never
    }
  }
  result.customers = Object.values(customerData)
  return result as { apiKey: string; customers: TCustomer[] }
}

export const getTransporeonGroupStructure = (
  uniqueID: string | number,
  disabled?: boolean,
  integrationConfigurationID?: string
) => {
  return {
    [uniqueID]: [
      {
        disabled: disabled || false,
        integrationConfigurationID: integrationConfigurationID || '',
        isRequired: true,
        labelText: 'Customer Name ( In Chaine )',
        name: `customerNameInChaine-${uniqueID}`,
        placeholder: "Enter the customer's name in Chaine"
      }
    ]
  }
}

export const getTransporeonPayloadStructure = (
  event: Record<string, string>
): { customers: TCustomer[]; password: string; username: string } => {
  const result: Record<string, string | TCustomer[]> = {
    customers: [],
    password: event.password,
    username: event.username
  }
  const customerData: Record<string, TCustomer> = {}
  for (const [key, value] of Object.entries(event)) {
    const match = key.match(/(customerNameInChaine)-(.+)/)
    if (match) {
      const [, property, id] = match
      if (!customerData[id]) {
        customerData[id] = {
          customerNameInChaine: null
        } as TCustomer
      }
      customerData[id][property as keyof TCustomer] = value as never
    }
  }
  result.customers = Object.values(customerData)
  return result as { customers: TCustomer[]; password: string; username: string }
}
